<template>
    <div class="d-flex justify-content-end align-items-end flex-column">
        <small class="text-bold text-muted mb-1">{{ webClassData.session_length }}</small>
        <div class="d-flex justify-content-end">
            <small class="mr-3">🗓 {{ webClassData.session.date }}</small>
            <small class="mb-0">🕑 {{ webClassData.session.time }}</small>
        </div>
        <b-button
            variant="secondary"
            size="sm"
            class="px-3"
            @click="handleCta">{{ buttonText }}</b-button>
    </div>
</template>

<script>
export default {
    name: "WebClassCardContent",
    props:{
        webClassData: {
            type: Object,
            required: true
        }
    },
    methods:{
        handleCta(){
            switch (this.webClassData.session.status){
                case 'not_registered':
                    this.$emit('openDetails', this.webClassData);
                    break;
                case 'waiting':
                    window.open(this.webClassData.session.url, '_blank');
            }
        }
    },
    computed:{
        buttonText(){
            switch (this.webClassData.session.status){
                case 'not_registered':
                    return this.trans('streams.dashboard.register');
                case 'waiting':
                    return this.trans('streams.dashboard.access');
            }
        }
    }
}
</script>
